/**
 * @fileOverView
 * @description Vyb Model<br>
 * @copyright 2015-present Flatirontek LLC
 **/

var AmpersandModel = require('ampersand-model');
var app = require("ampersand-app");
var dialog = require("../lib/dialog");
var limits = require("../../../lib/notificationlimits");
var logText = require("../../../lib/logtext");
var integrationLinksTemplate = require('../templates/widgets/integrations.html');
var moderationTemplate = require('../templates/components/moderation.html');
var ScheduleView = require('../views/components/schedule');
var GeofenceView = require('../views/components/geofence');


var Vyb = AmpersandModel.extend({

    idAttribute: 'key',

    urlRoot: function(){
        return app.config.restApiUrl + "/vyb";
    },

    ajaxConfig: app.utils.setAuthTokenHeader,

    props: {
        key : 'string',
        name : 'string',
        description: 'string',
        dtlastcheck: 'string',
        frequency: 'number',
        type: 'string',
        status: 'string',
        pollUri: 'string',
        soundKey: 'string',
        triggerKey: 'string',
        subscriptionKey: 'string',
        access: 'string',
        numberFollowers: 'number',
        imageUrl: 'string',
        linkUrl: 'string',
        message: 'string',
        log: 'string',
        geofence: 'object',
        moderationStatus: 'string',
        moderationMessage: 'string',
        triggerType: 'string',
        triggerSettings: 'object',
        sendPermissions: 'string'
    },

    session: {
        editing: ['boolean', true, false],
        testing: ['boolean',true,false],
        diagnostics: ['object','true'],
        followersChanged : ['boolean',true,false],
        pinging: ['boolean',true,false]
    },

    derived: {

        partialDescription: {
            deps: ['description'],
            fn: function () {
                var desc = this.description.substr(0,128);
                if(this.description.length>128) desc += " . . . ";
                return desc;
            }
        },
        onOff:{
            deps: ['status'],
            fn: function(){
                return this.status=='on' ? true: false;
            }
        },
        switchKeyInput:{
            deps: ['key'],
            fn: function(){
                return "switch-" + this.key;
            }
        },
        switchKeyLabel:{
            deps: ['key'],
            fn: function(){
                return "switch-" + this.key;
            }
        },
        runOnceOn:{
            deps: ['triggerSettings'],
            fn: function(){
                return (this.triggerSettings && this.triggerSettings.runOnce) ? true : false;
            }
        },
        displayFrequency:{
            deps: ['frequency'],
            fn: function(){
                var freq = this.frequency;
                var map = {
                    "5" : "5 minutes",
                    "15" : "15 minutes",
                    "30" : "30 minutes",
                    "60" : "1 hour",
                    "120" : "2 hours",
                    "240" : "4 hours",
                    "480" : "8 hours",
                    "1440" : "1 day",
                    "10080" : "1 week"
                };
                return map[freq];
            }
        },

        displayFollowers:{
            deps: ['numberFollowers'],
            fn: function(){
                var msg = null;
                if(this.numberFollowers==1) msg = '1 peep is following this vybit';
                if(this.numberFollowers>1) msg = this.numberFollowers + ' peeps are following this vybit';
                if(msg) msg += '. Each send reaches ' + (this.numberFollowers + 1) + ' people and uses ' + (this.numberFollowers + 1) + ' notifications.';
                return msg;
            }
        },

        eventUri: {
            deps: ['type','triggerKey'],
            fn: function(){
                return app.config.baseApiUrl + '/trigger/' + this.triggerKey;
            }
        },
        subscriptionLinks: {
            deps: ['subscriptionKey','access'],
            fn: function(){
                var directLink =  app.config.baseApiUrl + '/subscribe/' + this.subscriptionKey;
                var cardLink = app.config.wwwHost + '/subscription/' + this.subscriptionKey;

                var html = '<div><span class="vslabel">DIRECT: </span><span id="directLink">'+directLink+'</span></div>';

                html = html + '<div><span class="vslabel">CARD: &nbsp; </span><span id="cardLink"><a href="http://'+cardLink+'" target="_blank" onclick="app.utils.cancelBubble()">https://' + cardLink + '</a></span></div>';

                return html;
            }
        },

        subscriptionCopyButtons: {
            deps : ['access'],
            fn: function(){
                var buttonDiv = '<button class="btn btn-sm btn-info vcopybutton" data-clipboard-target="#directLink">COPY</button>';
                buttonDiv += '<button class="btn btn-sm btn-info vcopybutton" data-clipboard-target="#cardLink">COPY</button>\n';

                return buttonDiv;
            }
        },

        docCreateLink: {
            deps: ['key'],
            fn: ()=> app.vyb.docLink('create')
        },

        docTriggerLink: {
            deps: ['key'],
            fn: ()=> app.vyb.docLink('trigger')
        },

        docSubscriptionLink: {
            deps: ['key'],
            fn: ()=> app.vyb.docLink('sharing')
        },

        headerleft: {
            deps: ["editing"],
            fn: function(){
                return this.editing ? "" : "";
            }
        },
        headerright: {
            deps: ["editing"],
            fn: function(){
                return this.editing ? "" : "";
            }
        },
        headerleftclass: {
            deps: ["editing"],
            fn: function(){
                return this.editing ? "vback" : "vback";
            }
        },
        headerrightclass: {
            deps: ["editing"],
            fn: function(){
                return this.editing ? "" : "";
            }
        },
        displayDiagnostics: {
            deps: ["diagnostics"],
            fn: function(){
                var diagnostics = app.YAML.stringify(this.diagnostics);
                return diagnostics.toString().replace(/response/,"<br/>response");
            }
        },
        maintitle: {
            fn: function(){
                return 'Vyb';
            }
        },

        soundName: {
            deps: ['soundKey'],
            fn: function(){

                var sound = null;

                if(app.usedSounds.get(this.soundKey)!=undefined){
                    sound = app.usedSounds.get(this.soundKey);
                }else if(app.sounds.get(this.soundKey)!=undefined){
                    sound = app.sounds.get(this.soundKey);
                }

                soundInfo = sound!=null ? sound.name : "";

                if(sound!=null && sound.status!=undefined && sound.status=="private"){
                    soundInfo += ' <span class="vcredit">private: ' + sound.meta.source + ' ' + sound.originalUri +'</span>';

                }else if(sound!=null && sound.meta!=null && sound.meta.source!=null){
                    soundInfo += ' &nbsp; <span class="vcredit">from <a class="vcreator" target="_new" href="'+sound.meta.source+'" onclick="event.stopImmediatePropagation()">freesound.org</a></span>';
                }

                return soundInfo;
            }
        },

        shakeElement: {
            deps: ['pinging'],
            fn: function(){
                if(this.pinging) return true;
                else return false;
            }
        },

        integrationLinks: {
            deps: ['key'],
            fn: function(){
                return integrationLinksTemplate();
            }
        },

        moderationShow: {
            deps: ['access'],
            fn: function(){
                if(this.access=="public") return true;
                else return false;
            }
        },

        moderationDisplay: {
            deps: ['moderationStatus','access'],
            fn: function(){
                if(this.access==undefined || this.moderationStatus==undefined) return '';
                var modEl = app.utils.createDomElementFromString(moderationTemplate());
                var status = this.moderationStatus;
                if(status=='review') status = 'Under Review';

                if(this.moderationStatus!="editing") modEl.querySelector('button.vmod_button').remove();

                var moderationMessageDisplay = this.moderationMessage || 'notes following review will appear here.';

                if(app.profile.type=="admin"){
                    modEl.querySelector("button.btn-primary").classList.remove("vhide");
                    modEl.querySelector("button.btn-danger").classList.remove("vhide");
                    moderationMessageDisplay = '<textarea name="moderationMessage" class="vtextarea">'+ this.moderationMessage +'</textarea>';
                }

                modEl.querySelector('span.vmod_modstatus').textContent = status;
                modEl.querySelector('div.vmod_message').innerHTML = '<b>REVIEW NOTES:</b> ' + moderationMessageDisplay;
                return modEl.outerHTML;
            }
        },

        ownerShip: {
            deps: ['access','moderationStatus'],
            fn: function(){
                if(this.access=="public"){
                    var vstatus = "vreviewing";
                    if(this.moderationStatus=="approved") vstatus = "vapproved";
                    if(this.moderationStatus=="rejected") vstatus = "vrejected";
                    var peeps = this.numberFollowers>1 ? "peeps" : "peep";
                    return '<span class="vpublic '+ vstatus +'">PUBLIC &nbsp; </span>' +
                        '<span class="vpeeps">'+ this.numberFollowers +' peeps</span>';

                }else if(this.access=="unlisted"){
                    return '<span class="vunlisted">UNLISTED &nbsp; </span>' +
                        '<span class="vpeeps">'+ this.numberFollowers +' peeps</span>';

                }else if(this.access=="private" && this.numberFollowers>0){
                    return '<span class="vprivate">PRIVATE &nbsp; </span>' +
                        '<span class="vpeeps">'+ this.numberFollowers +' peeps</span>';
                }
                return '';
            }
        },

        hideSettings: {
            deps: ['key'],
            fn: function(){
                if(this.key==undefined) return true;
                else return false;
            }
        },

        schedule: {
            deps: ['triggerType','triggerSettings'],
            fn: function(){
                if(this.triggerType!='schedule') return '';
                const clickHereSpan = '<span class="vset">click here to set</span>';
                if(this.triggerSettings==null
                    || this.triggerSettings.crons==undefined
                    || this.triggerSettings.crons[0]==undefined) return '<div class="vplaceholder">'+clickHereSpan+'</div>';

                var crons = this.triggerSettings.crons;
                var sentencesHtml = '';
                for (var i = 0; i < crons.length; i++) {
                    var sentence = app.utils.cronToHumanReadable(crons[i].cron);
                    if (crons.length > 1) {
                        sentencesHtml += '<div class="vts-sentence">' + (i+1) + '. ' + sentence + '</div>';
                    } else {
                        sentencesHtml += '<div class="vts-sentence">' + sentence + '</div>';
                    }
                }

                var timezone = crons[0].timeZone || '';

                var scheduleView = new ScheduleView({
                    schedule_sentences: sentencesHtml,
                    schedule_timezone: timezone
                });
                scheduleView.render();
                return scheduleView.el.outerHTML;
            }
        },

        reminders: {
            deps: ['triggerType','triggerSettings'],
            fn: function(){
                if(this.triggerType!='reminders') return '';
                const clickHereSpan = '<span class="vset">click here to set</span>';
                if(this.triggerSettings==null
                    || this.triggerSettings.reminders==undefined
                    || this.triggerSettings.reminders.length==0) return '<div class="vplaceholder">'+clickHereSpan+'</div>';

                var reminders = this.triggerSettings.reminders;
                var html = '<div class="vts-reminders-display">';
                html += '<div class="vts-sentence">' + reminders.length + ' reminder' + (reminders.length > 1 ? 's' : '') + ' set</div>';
                for (var i = 0; i < reminders.length && i < 3; i++) {
                    var r = reminders[i];
                    var dateStr = app.utils._cronToDateDisplay(r.cron, r.timeZone, r.year);
                    html += '<div class="vts-sentence" style="font-size:12px">' + dateStr;
                    if (r.message) {
                        var msg = r.message.length > 30 ? r.message.substring(0, 30) + '...' : r.message;
                        html += ' <span class="vts-reminder-msg">' + logText.escapeHtml(logText.stripTags(msg)) + '</span>';
                    }
                    var imageUrl = logText.safeUrl(r.imageUrl), linkUrl = logText.safeUrl(r.linkUrl);
                    if (imageUrl) html += ' <a class="vts-reminder-msg" href="' + logText.escapeHtml(imageUrl) + '" target="_blank" onclick="app.utils.cancelBubble()">[img]</a>';
                    if (linkUrl) html += ' <a class="vts-reminder-msg" href="' + logText.escapeHtml(linkUrl) + '" target="_blank" onclick="app.utils.cancelBubble()">[link]</a>';
                    html += '</div>';
                }
                if (reminders.length > 3) {
                    html += '<div class="vts-sentence" style="font-size:11px;color:#888">+ ' + (reminders.length - 3) + ' more</div>';
                }
                html += '</div>';
                return html;
            }
        },

        geofenceDisplay: {
            deps: ['triggerType','geofence'],
            fn: function(){
                if(this.triggerType!='geofence') return '';
                const clickHereSpan = '<span class="vset">click here to set</span>'
                if(this.geofence==null) return '<div class="vplaceholder">'+clickHereSpan+'</div>';

                var mapUri = `https://google.com/maps/?q=${this.geofence.lat},${this.geofence.lon}`;
                var mapLink = `<a onclick="app.utils.cancelBubble()" href="${mapUri}" target="_blank">map link</a>`;

                var geofenceView = new GeofenceView({
                    glocation: `${this.geofence.lat}, ${this.geofence.lon}`,
                    gmap: mapLink,
                    gradius: this.geofence.displayRadius,
                    gradius_units: this.geofence.radiusUnits || 'meters',
                    gtype: `${this.geofence.type || 'enter'}ing`,
                    gtime: `${this.geofence.timeThrottle} hours`,
                    gsub: `${this.geofence.subscribable==undefined || this.geofence.subscribable=="no" ? 'only my devices' : 'allow subscriber devices'}`
                });
                geofenceView.render();
                return geofenceView.el.outerHTML;
            }
        },

        sendPermissionsDisplay: {
            deps: ['sendPermissions'],
            fn: function(){
                const labels = {
                    'owner_subs': 'Only I can send notifications to subscribers',
                    'subs_owner': 'Allow subscribers to send notifications to me',
                    'subs_group': 'Allow subscribers to send notifications to the entire group'
                };
                const value = this.sendPermissions || 'owner_subs';
                return labels[value] || labels['owner_subs'];
            }
        },

    },

    updateTriggerSettings: function(mutator){
        var ts = JSON.parse(JSON.stringify(this.triggerSettings || {}));
        mutator(ts);
        this.set('triggerSettings', ts);
        this.trigger('change:triggerSettings');
    },

    patch: function(data,paramModel=null){

        var key = Object.keys(data)[0];
        var value = data[key];

        //strip html
        if(typeof(value)=="string") value = app.utils.stripFieldHtml(key, value);

        //prepend urls with https if needed
        if(key.match("Url") && value.length>0){
            value = value.match(/^http(s|):\/\//) ? value : "https://" + value;
        }

        data[key] = value;

        //validation
        if(!this.validated(key, value)) return;

        var newVyb = key=="name" && this.key==undefined ? true : false;
        var patch = newVyb ? false : true;

        // Store original soundKey for fs: import detection
        var originalSoundKey = null;
        if(key === "soundKey" && value && value.startsWith('fs:')) {
            originalSoundKey = value;
        } else if(this.soundKey && this.soundKey.startsWith('fs:')) {
            originalSoundKey = this.soundKey;
        }

        //moderation related
        if(!newVyb && key.match(/^(name|description|message|log|imageUrl|linkUrl|soundKey)$/)){
            this.set('moderationStatus','editing');
            this.set('moderationMessage','');
            data['moderationStatus'] = this.moderationStatus;
            data['moderationMessage'] = this.moderationMessage;
        }

        if(key=="soundKey" && (this.soundKey!=undefined && this.soundKey.length>0)){
            var soundKey = key=="soundKey" ? value : this.soundKey;

            if(!soundKey.startsWith('fs:')) {
                var sound = app.sounds.get(soundKey,'key');
                if(sound!=undefined){
                    app.fsutils.soundSetUp(sound);
                    app.usedSounds.add(sound);
                }else{
                    sound = new app.Sound({key:soundKey});
                    sound.fetch({
                        success: function(model,response){
                            app.fsutils.soundSetUp(sound);
                            app.usedSounds.add(sound);
                        },
                        error: function(error){
                            console.log('error loading sound ' + soundKey);
                        }
                    });
                }
            }
        }

        var appRef = app;

        this.save(data,{
            patch: patch,
            wait: true,
            success: function(model,response){
                appRef.header.set('editing',false);
                if(newVyb){
                    appRef.vybs.add(model,{at:0});
                    appRef.loadMeter();
                }
                if(paramModel!=null){
                    paramModel.set('editing',false);
                }

                var returnedSoundKey = model.soundKey;

                if(returnedSoundKey && originalSoundKey && returnedSoundKey !== originalSoundKey) {
                    if(appRef.usedSounds.get(originalSoundKey, 'key')) {
                        appRef.usedSounds.remove(originalSoundKey, 'key');
                    }

                    if(!appRef.sounds.get(returnedSoundKey, 'key')) {
                        var newSound = new appRef.Sound({key: returnedSoundKey, type: 'mp3'});
                        newSound.id = returnedSoundKey;
                        newSound.fetch({
                            success: function(soundModel, soundResponse) {
                                appRef.sounds.add(soundModel);
                                appRef.usedSounds.add(soundModel);
                                appRef.fsutils.soundSetUp(soundModel);

                                model.trigger('change');
                                model.trigger('change:soundKey');
                                model.trigger('change:soundName');

                                var vybInCollection = appRef.vybs.get(model.key, 'key');
                                if(vybInCollection && vybInCollection !== model) {
                                    vybInCollection.set('soundKey', returnedSoundKey);
                                }

                                if(appRef.vyb && appRef.vyb.key === model.key) {
                                    appRef.vyb.trigger('change');
                                    appRef.vyb.trigger('change:soundKey');
                                    appRef.vyb.trigger('change:soundName');
                                }
                            },
                            error: function(error) {
                                console.log('error loading imported sound ' + returnedSoundKey, error);
                            }
                        });
                    }
                } else if(appRef.sounds.get(model.soundKey)){
                    var sound = appRef.sounds.get(model.soundKey);
                    sound.set('toggle',sound.toggle ? false:true);
                }

                if(data.name!=undefined) appRef.header.set('maintitle',data.name);

                if(appRef.vyb.triggerType=="geofence"){
                    if(data.triggerType!=undefined || data.geofence!=undefined) appRef.glutils.manage();
                }
            },
            error: function(model,response,options){
                console.log('error');
                if(response.statusCode==400 && response.body.error == "duplicate_name") dialog.alert('Vybit name "'+data.name+'" is invalid or already exists.');
                else if(response.statusCode==403  && response.body.error == "vybit_limit_reached") dialog.alert('Vybit limit reached. Visit my.vybit.net to increase account limit.')
                else if(response.statusCode==400 && response.body.message) dialog.alert(response.body.message);
                if(paramModel!=null) paramModel.set('editing',false);
                appRef.header.set('editing',false);
            }
        });
    },

    validated: (key, value) => {

        //urls
        if(key.match("Url") && value.length>0 && !app.utils.isValidURL(value)){
            dialog.alert("Invalid URL");
            return false;
        }

        var maxLength = key=="message" ? limits.MESSAGE_MAX_LENGTH : key=="log" ? limits.LOG_MAX_LENGTH : null;
        if(maxLength && value.length > maxLength){
            dialog.alert("The " + key + " can be up to " + maxLength.toLocaleString() + " characters.");
            return false;
        }

        return true;
    },

    docLink: (section) => {
            return '<a href="http://www.vybit.net#'+ section +'" target="_blank" onclick="app.utils.cancelBubble()">'+ app.utils.docSectionTitleMap(section)+'</a>';
    }
});

module.exports = Vyb;
